import { z } from "zod/v4";
import { resultRowSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export interface ResultsParams {
	tournament?: string;
	athlete?: string;
	minPlacement?: number;
	limit?: number;
}

export const results = {
	list: (params: ResultsParams = {}) => {
		const query = new URLSearchParams();
		if (params.tournament) query.set("tournament", params.tournament);
		if (params.athlete) query.set("athlete", params.athlete);
		if (params.minPlacement != null) query.set("minPlacement", String(params.minPlacement));
		if (params.limit) query.set("limit", String(params.limit));
		const qs = query.toString();
		return fetchApi(`/results${qs ? `?${qs}` : ""}`, z.array(resultRowSchema));
	},
};
